import {
  getBaseShopPicksPerStage,
  getBaseShopRerollsPerStage,
  getRoundDiscards,
  getRoundSubmits,
  getShopRarityChances,
  normalizeRunSettings,
} from '../config/runSettings';
import { normalizeActiveGameEffects } from '../engine/scoringEffects';

export const sumActiveGameEffectValue = (activeGameEffects, effectType, valueKey) =>
  normalizeActiveGameEffects(activeGameEffects)
    .filter((effect) => effect.type === effectType)
    .reduce((acc, effect) => acc + Math.max(0, Number(effect?.[valueKey]) || 0), 0);

export const getRoundSubmitsWithEffects = (runSettings, activeGameEffects = []) =>
  getRoundSubmits(runSettings) +
  sumActiveGameEffectValue(activeGameEffects, 'GLOBAL_ROUND_SUBMITS_BONUS', 'bonusSubmits');

export const getRoundDiscardsWithEffects = (runSettings, activeGameEffects = []) =>
  getRoundDiscards(runSettings) +
  sumActiveGameEffectValue(activeGameEffects, 'GLOBAL_ROUND_DISCARDS_BONUS', 'bonusDiscards');

export const getShopRerollsWithEffects = (runSettings, activeGameEffects = []) =>
  getBaseShopRerollsPerStage(runSettings) +
  sumActiveGameEffectValue(activeGameEffects, 'GLOBAL_SHOP_REROLLS_BONUS', 'bonusRerolls');

export const getShopPicksWithEffects = (runSettings, activeGameEffects = []) =>
  getBaseShopPicksPerStage(runSettings) +
  sumActiveGameEffectValue(activeGameEffects, 'GLOBAL_SHOP_PICKS_BONUS', 'bonusPicks');

export const getShopRarityChancesWithEffects = (runSettings, activeGameEffects = []) => {
  const baseChances = { ...getShopRarityChances(runSettings) };
  const normalizedEffects = normalizeActiveGameEffects(activeGameEffects);

  normalizedEffects
    .filter((effect) => effect.type === 'GLOBAL_SHOP_RARITY_CHANCE_BONUS')
    .forEach((effect) => {
      const rarityKey = String(effect.rarity || '').trim().toLowerCase();
      if (!(rarityKey in baseChances)) {
        return;
      }

      const bonusChance = Number(effect.bonusChance || 0);
      if (!Number.isFinite(bonusChance) || bonusChance === 0) {
        return;
      }

      baseChances[rarityKey] = Math.max(0, Number(baseChances[rarityKey] || 0) + bonusChance);
    });

  return baseChances;
};

export const createInitialRunSettings = () => normalizeRunSettings();
